// src/firebase/config.js
import { initializeApp }  from "firebase/app";
import { getAuth }        from "firebase/auth";
import { getDatabase }    from "firebase/database";
import { getFirestore }   from "firebase/firestore";
import { getStorage }     from "firebase/storage";

// ─────────────────────────────────────────────────────────────────────────────
//  Firebase Console → Project Settings → Your apps → SDK setup and config
//  bölümünden kopyaladığın değerleri aşağıya yapıştır.
// ─────────────────────────────────────────────────────────────────────────────
const firebaseConfig = {
  apiKey:            "AIzaSyC8R1BwoiGh7I_d0wGH8w45-oi9wt5dK4E",
  authDomain:        "bonecast-ceed1.firebaseapp.com",       // örn: bonecast-ceed1.firebaseapp.com
  projectId:         "bonecast-ceed1",        // örn: bonecast-ceed1
  storageBucket:     "bonecast-ceed1.firebasestorage.app",    // örn: bonecast-ceed1.firebasestorage.app
  messagingSenderId: "341882494222",
  appId:             "1:341882494222:web:ca15b1d58585ccae8ecb5f",            // örn: 1:123456789:web:abc123
  databaseURL:       "https://bonecast-ceed1-default-rtdb.europe-west1.firebasedatabase.app",
};

// ─── Tek app örneği — tüm servisler bu instance'tan türer ───────────────────
const app = initializeApp(firebaseConfig);

export const auth      = getAuth(app);
export const db        = getDatabase(app);
export const firestore = getFirestore(app);
export const storage   = getStorage(app);   // deleteUserAccount için zorunlu

export default app;
